"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardHeader = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var cardHeader = {
  colors: {
    default: {
      background: _colors.colors.backgroundCard,
      borderBottom: _colors.colors.borderCard
    }
  },
  padding: {
    default: '0.75rem 1.25rem'
  },
  borderRadius: {
    noRadius: _utils.utils.borderRadius.noRadius,
    topLeftRight: 'calc(0.25rem - 1px)'
  },
  border: _utils.utils.border
};
exports.cardHeader = cardHeader;